<div class="container" @appear>
  <div class="header">
    <div class="back" matRipple (click)="close()">
      <mat-icon>chevron_left</mat-icon>
      <span i18n>Zurück zum Projekt</span>
    </div>

    <div class="team-name">
      <span i18n>Team Dashboard:</span>
      <span>{{ team.name }}</span>
    </div>
  </div>
  <mat-tab-group [selectedIndex]="0" color="primary" backgroundColor="primary">
    <mat-tab i18n-label label="Übersicht">
      <ng-template matTabContent>
        <div class="tab-container"><dt-team-overview [teamId]="team.id"></dt-team-overview></div
      ></ng-template>
    </mat-tab>
    @if (doesUserHaveOwnerRights) {
      <mat-tab i18n-label label="Mitglieder">
        <ng-template matTabContent>
          <div class="tab-container"
            ><dt-team-members
              [teamId]="team.id"
              [userMemberId]="teamProject.userMember.id"
              (lostModeratorRight)="reopen()"
            ></dt-team-members></div
        ></ng-template>
      </mat-tab>
      <mat-tab i18n-label label="Aufgabenverwaltung">
        <ng-template matTabContent>
          <div class="tab-container"><dt-team-tasks [teamId]="team.id"></dt-team-tasks></div></ng-template
      ></mat-tab>
      <mat-tab i18n-label label="Zielgewichte">
        <ng-template matTabContent>
          <div class="tab-container">
            <dt-team-dashboard-objective-weights [teamId]="team.id"></dt-team-dashboard-objective-weights>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab i18n-label label="Auswertung">
        <ng-template matTabContent>
          <div class="tab-container">
            <dt-team-dashboard-utility [teamId]="team.id"></dt-team-dashboard-utility>
          </div>
        </ng-template>
      </mat-tab>
    }

    <mat-tab i18n-label label="Einstellungen">
      <div class="tab-container">
        <dt-team-settings [team]="team" [isUserOwner]="isUserOwner" [doesUserHaveOwnerRights]="doesUserHaveOwnerRights"></dt-team-settings>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
